import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SEO from "../seo";
import API from "../api/api";

import Sidebar from "../components/Sidebar";
import LatestArticlesSidebar from "../components/LatestArticlesSidebar";
import RelatedArticlesSidebar from "../components/RelatedArticlesSidebar";
import TagSidebar from "../components/TagSidebar";

export default function TagPage() {
    const { tag } = useParams();

    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        API.get(`/api/articles/tags/${tag}`)
            .then((res) => {
                setArticles(res.data.articles || []);
                setLoading(false);
            })
            .catch(() => {
                setArticles([]);
                setLoading(false);
            });
    }, [tag]);

    // ---------- Helpers ----------
    const readableTag = tag
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    return (
        <>
            <SEO
                title={`Tag: ${readableTag}`}
                description={`Latest articles related to ${readableTag}`}
            />

            <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 lg:grid-cols-3 gap-10">

                {/* ================= LEFT CONTENT ================= */}
                <div className="lg:col-span-2">

                    {/* TAG TITLE */}
                    <h1 className="text-4xl font-bold mb-12">
                        Tag: {readableTag}
                    </h1>

                    {loading && (
                        <p className="text-center text-gray-500">Loading articles...</p>
                    )}

                    {!loading && articles.length === 0 && (
                        <p className="text-center text-gray-500">
                            No articles found.
                        </p>
                    )}

                    {/* ARTICLE LIST */}
                    <div className="space-y-12">
                        {articles.map((article) => (
                            <div
                                key={article.id}
                                className="grid grid-cols-1 md:grid-cols-2 gap-8 pb-10 border-b border-red-300"
                            >
                                {/* IMAGE */}
                                <Link to={`/article/${article.slug}`}>
                                    {article.images ? (
                                        <img
                                            src={article.images}
                                            alt={article.title}
                                            className="w-full h-64 object-cover"
                                        />
                                    ) : (
                                        <div className="w-full h-64 bg-gray-200 flex items-center justify-center text-gray-500">
                                            No Image
                                        </div>
                                    )}
                                </Link>

                                {/* CONTENT */}
                                <div className="flex flex-col justify-center">
                                    <Link to={`/article/${article.slug}`}>
                                        <h2 className="text-2xl font-bold leading-snug hover:text-blue-600">
                                            {article.title}
                                        </h2>
                                    </Link>

                                    {/* META */}
                                    <div className="flex items-center gap-4 text-sm text-gray-500 mt-2">
                                        <span>{article.author?.name || "Admin"}</span>
                                        <span>•</span>
                                        <span>{formatDate(article.created_at)}</span>
                                        <span>•</span>
                                        <span className="flex items-center gap-1">
                                            <i className="fa-regular fa-eye"></i>
                                            {article.views || 0}
                                        </span>
                                    </div>

                                    {/* EXCERPT (5 lines) */}
                                    <div
                                        className="text-gray-600 mt-4 prose max-w-none"
                                        style={{
                                            display: "-webkit-box",
                                            WebkitLineClamp: 5,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: article.content,
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ================= RIGHT SIDEBAR ================= */}
                {/* ================= RIGHT SIDEBAR ================= */}
                <div className="hidden lg:block">
                    <div className="sticky top-24 space-y-8">
                        <div className="border border-red-300 rounded-lg">
                            <Sidebar />
                        </div>

                        <div className="border border-red-300 rounded-lg">
                            <LatestArticlesSidebar />
                        </div>

                        <div className="border border-red-300 rounded-lg">
                            <RelatedArticlesSidebar />
                        </div>

                        <div className="border border-red-300 rounded-lg">
                            <TagSidebar tags={[readableTag]} />
                        </div>
                    </div>
                </div>

            </div >
        </>
    );
}
